import { language } from "shared/language";

export const ROLE_EXISTED = language.role_existed;
export const ROLE_NOT_FOUND = language.role_not_found;
